/* eslint-disable */
import {createStyles, Theme, withStyles} from "@material-ui/core";
import {Checkbox, Heading} from "@chakra-ui/react";
import {withTranslation} from "react-i18next";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, {Component, Key} from "react";
import {connect} from "react-redux";

import {edit_Properties, getAllProperties,} from "../../../utils/store/actions/users.actions";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    downloadBS: {
      margin: "20px",
    },
  });
class ModuleConfiguration extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      party: "",
    };
  }
  async componentDidMount() {
  }

  handleChangeProperty(e: any, prop: any) {
    this.props.edit_Properties({
      key: prop.key,
      value: e.target
        ? e.target.checked !== undefined
          ? e.target.checked
          : e.target.value
        : e.value,
    });
  }

  render() {
    const { classes, t } = this.props;
    const isV4Available = this.props.Users?.get_properties?.some(
      (property: { key: string; value: string }) => property.key === "IS_V4_AVAILABLE" && property.value === "true");
    const propertyItem = (property: { id: Key; key: string; value: string }) => {
      return (
        <ListItem key={property.id}>
          <Checkbox
            value={property.value}
            style={{marginTop: "10px", marginRight: "5px"}}
            defaultIsChecked={
              property.value === "true" ? true : false
            }
            onChange={(e: any) => {
              this.handleChangeProperty(e, property);
            }}
            edge="end"
            inputProps={{
              "aria-labelledby": `checkbox-list-label-${property}`,
            }}
          />
          <ListItemText
            id={property.key}
            primary={t(property.key)}
          />
        </ListItem>
      );
    }

    return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          aria-controls="panel2a-content"
          id="modules"
        >
          <Typography className={classes.heading}>
            {isV4Available ? "Modules/Operations/Settings" : "Modules/Operations"}
          </Typography>
        </AccordionSummary>
        <div style={{display: "flex", flexDirection: "column"}}>
          <AccordionDetails
            style={{display: "flex", flexDirection: "column"}}
          >
            <Heading
              fontSize="16px"
              color="#ae0064"
              fontWeight="normal"
              fontFamily="ABeeZee"
              mt={2}
              mb={2}
            >
              {"StandAlone"}
            </Heading>
            <List
              style={{maxHeight: 400, overflow: "auto"}}
              className={classes.root}
            >
              {this.props.Users?.get_properties?.filter((property: any) => ['FUNDRAISING_STANDALONE'].includes(property.key))
                .map(propertyItem)
              }
            </List>
          </AccordionDetails>
          <AccordionDetails
            style={{display: "flex", flexDirection: "column"}}
          >
            <Heading
              fontSize="16px"
              color="#ae0064"
              fontWeight="normal"
              fontFamily="ABeeZee"
              mt={2}
              mb={2}
            >
              {"Modules"}
            </Heading>
            <List
              style={{maxHeight: 400, overflow: "auto"}}
              className={classes.root}
            >
              {this.props.Users?.get_properties?.filter((property: any) =>
                ((!["FUNDRAISING_STANDALONE"].includes(property.key)
                    || (property.key.startsWith("ENABLE_PARTY_")
                      && !["ENABLE_PARTY_PRODUCT"].includes(property.key)))
                  && property.propertyType === "MODULE") ||
                ['LOGIN_V2'].includes(property.key))
                .map(propertyItem)
              }
            </List>
          </AccordionDetails>
          <AccordionDetails
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Heading
              fontSize="16px"
              color="#ae0064"
              fontWeight="normal"
              fontFamily="ABeeZee"
              mt={2}
              mb={2}
            >
              {"Operations"}
            </Heading>
            <List
              style={{ maxHeight: 400, overflow: "auto" }}
              className={classes.root}
            >
              {this.props.Users?.get_properties?.filter((property: any) =>
                property.key.startsWith("ENABLE_OPERATION_"))
                .map(propertyItem)
              }
            </List>
          </AccordionDetails>
          {isV4Available && <AccordionDetails
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Heading
              fontSize="16px"
              color="#ae0064"
              fontWeight="normal"
              fontFamily="ABeeZee"
              mt={2}
              mb={2}
            >
              {"Settings"}
            </Heading>
            <List
              style={{ maxHeight: 400, overflow: "auto" }}
              className={classes.root}
            >
              {this.props.Users?.get_properties?.filter((property: any) => property.key.includes('IS_SETTING_OBJECTIVES_MANAGEMENT'))
                .map(propertyItem)
              }
            </List>
          </AccordionDetails>}
        </div>
      </Accordion>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllProperties,
  edit_Properties
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(ModuleConfiguration)));
